<template>
  <div id="page" ref="homePage" class="page">
    <img class="banner" src="@/modules/interview/images/banner.png">
    <process :process-val="3" />
    <!-- 支付成功 -->
    <div class="main">
      <div class="icon-face" />
      <div class="content-box">
        <div class="result-text">你已支付成功</div>
      </div>
      <div class="content-hint">
        <div class="big">本次支付订单信息</div>
        <div v-if="orderId" class="order-item">
          <div class="item-key">支付单号</div>
          <div>{{ orderId }}</div>
        </div>
        <div v-if="payprice" class="order-item">
          <div class="item-key">支付金额</div>
          <div>{{ payprice }}</div>
        </div>
        <div v-if="interview_number && interview_number > 0" class="order-item">
          <div class="item-key">参与营期</div>
          <div>第{{ interview_number }}期</div>
        </div>
        <div v-if="interview_city && interview_city > 0" class="order-item">
          <div class="item-key">城市营</div>
          <div>{{ interview_city | cityF }}</div>
        </div>
      </div>
      <div class="bottom-slogan" />
    </div>
    <div class="submit-btn" @click="goToIndex">下一步</div>
  </div>
</template>

<script>
import process from '../components/process'
import { checkUserOrder } from '@/api/purchase'
import { getLogin } from '@/utils/auth' // 获取auth参数
import { getUrlKey } from '@/utils/index' // 获取url参数

export default {
  name: 'PaySucceed',
  components: {
    process
  },
  filters: {
    cityF(val) {
      var list = ['未设置', '广州营', '深圳营', '北京营', '上海营', '成都营', '杭州营']
      return list[val]
    }
  },
  data: function() {
    return {
      winH: 0,
      type: undefined,
      orderId: undefined,
      order_sn: undefined,
      payprice: undefined,
      interview_city: undefined,
      interview_number: undefined
    }
  },
  created() {
    const that = this
    setTimeout(function() {
      that.winH = document.documentElement.clientHeight || document.body.clientHeight
      that.$refs.homePage.style.minHeight = that.winH + 'px'
    }, 300)
    var order_sn = this.$route.query.orderId || getUrlKey('orderId')
    this.type = this.$route.query.type
    this.order_sn = order_sn
    this.interview_city = sessionStorage.getItem('interview_city')
    this.interview_number = sessionStorage.getItem('interview_number')
    if (order_sn) {
      this.checkUserOrder()
    } else {
      // this.$router.replace('/')
    }
  },
  methods: {
    // 确认用户是否支付（微信环境下
    checkUserOrder() {
      var that = this
      checkUserOrder({
        open_id: getLogin(),
        'ordersn': this.order_sn
      }).then(res => {
        if (res.data.code === 200) {
          var data = res.data.data.list[this.order_sn][0]
          that.orderId = data.payid
          that.payprice = data.payprice
        }
      })
    },
    goToIndex() {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    position: relative;
    width: 375px;
    padding-top: 20px;
    .banner{
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
  .main{
    position: relative;
    top: 0;
    z-index: 1;
    width: 340px;
    margin: 0 auto;
    padding-top: 70px;
    padding-bottom: 40px;
    .content-box{
      position: relative;
      border-radius: 15px 15px 0 0;
      background: #fff;
      padding: 30px 25px 15px 25px;
      z-index: 2;
      .result-text{
        text-align: center;
        border-bottom: 1px solid #666;
        color: #ee5030;
        font-weight: bold;
        font-size: 20px;
        line-height: 40px;
        &.not{
          margin-top: 30px;
          color: #9d9d9d;
        }
      }
      .result-hint{
        padding: 20px 0 5px 0;
        color: #666;
        font-size:20px;
        line-height: 30px;
        text-align: center;
      }
    }
    .content-hint{
      position: relative;
      z-index: 1;
      padding: 10px 25px 20px 25px;
      border-radius: 0 0 15px 15px;
      background: #fff;
      line-height: 22px;
      font-size: 14px;
      &:after{
        position: absolute;
        top: 0;
        left: 25px;
        content: '';
        width: 16px;
        height: 2px;
        background: #ee5030;
        z-index: 1;
      }
      .big{
        display: inline-block;
        padding-bottom: 5px;
        color: #333;
        font-weight: bold;
      }
      .order-item{
        background: #ececec;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 8px;
        margin: 8px 0;
        .item-key{
          font-size: 15px;
          width: 140px;
        }
      }
    }
    .icon-face{
      position: relative;
      top: 22px;
      margin: -50px auto 0 auto;
      width: 45px;
      height: 45px;
      background: url("../images/icon_smile.png") no-repeat;
      background-size: 100%;
      z-index: 10;
      &.lose{
        background: url("../images/icon_wry.png") no-repeat;
        background-size: 100%;
      }
    }
    .bottom-slogan{
      border-radius: 0 0 15px 0;
      background: #fff;
      width: 50%;
      height: 25px;
      margin-left: 50%;
      padding-bottom: 10px;
      position: relative;
      top: -15px;
      &:before{
        content: '';
        font-size:0;
        border-style:solid;
        overflow:hidden;
        position:absolute;
        border-width:46px;
        border-color: transparent #fff transparent transparent;
        left:-92px;
        bottom:0;
      }
      .slogan-path{
        position: absolute;
        left: -50px;
        top: -15px;
        width: 200px;
        height: 100px;
        background: url("../images/slogan.png") no-repeat left center;
        background-size: 100%;
        z-index: 1;
      }
    }
  }
  .submit-btn{
    z-index: 99;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    background: #ee5030;
    line-height: 50px;
  }
</style>
